(function($){
    $('.wg-cookie a.close').on('click', function(e){
        e.preventDefault();
        $(this).closest('.wg-cookie').slideUp(500);
        if($(this).hasClass('set-wg-cookie')){
            $.ajax({
                url: ajax_obj.ajaxurl,
                method: 'post',
                data: {
                    'action': 'set_wg_cookie',
                    'nonce': ajax_obj.nonce
                }
            });
        }
    })
})(jQuery)